export default __webpack_public_path__ + "locales/zh-CN/PreparationPortal.json?hash=634d6ca58b3a2211265b32b1e23de409";